export default "__VITE_ASSET__doEpgaZ8__"